module.exports = __webpack_public_path__ + "img/login-banner.7a4617a0.png";